import {observer} from "mobx-react"
import {FieldInput} from "../../ui"
import {validationStore} from "../../../store"
import {FieldSelect} from "@kroschke/react-ui";
import {
    ScanDocumentRuleActionTypeDto,
    ScanDocumentRuleFieldTypeDto,
} from "../../../api/cms";
import {
    convertDocumentType,
    convertScanDocumentRuleAction,
    convertScanDocumentRuleField
} from "../../../api";
import {DocumentTypeDto} from "../../../api/sea";

export interface CmsRuleFormData {
    name: string
    field: ScanDocumentRuleFieldTypeDto
    value: string
    action: ScanDocumentRuleActionTypeDto
}

interface CmsRuleFormProps {
    data: CmsRuleFormData
    mode: 'create' | 'update',
    saving: boolean
    onChange: (value: CmsRuleFormData) => any
    validate: () => Promise<void>
}


const fieldOptions = Object.keys(ScanDocumentRuleFieldTypeDto).map(v => ({
    value: v,
    label: convertScanDocumentRuleField(v as ScanDocumentRuleFieldTypeDto)
}))

const actionOptions = Object.keys(ScanDocumentRuleActionTypeDto).map(v => ({
    value: v,
    label: convertScanDocumentRuleAction(v as ScanDocumentRuleActionTypeDto)
}))

const valueOptionsDocumentType = Object.keys(DocumentTypeDto).map(v =>({
    value: v,
    label: convertDocumentType(v as DocumentTypeDto)
}))

const CmsRuleForm = observer(function CmsForm({
                                              data,
                                              saving,
                                              onChange,
                                              validate
                                          }: CmsRuleFormProps) {
    const {
        name,
        field,
        value,
        action
    } = data
    const nameHelp = validationStore.getFor('data.name')
    const actionHelp = validationStore.getFor('data.action')
    const fieldHelp = validationStore.getFor('data.field')
    const valueHelp = validationStore.getFor('data.value')
    return <div style={{flex: '1', overflow: 'auto', padding: '1em'}}>

        <div style={{
            padding: '2em 1em',
            color: 'var(--core-primary-highlight-color)'
        }}>
            <span>Allgemeines</span>
        </div>

        <div style={{paddingBottom: '1em'}}>
            <div className={"columns"}>
                <div className={"column is-one-third"}>
                    <FieldInput
                        label={"Name"}
                        disabled={saving}
                        required={true}
                        invalid={Boolean(nameHelp)}
                        help={nameHelp}
                        value={name}
                        onBlur={async () => await validate()}
                        onChange={name => {
                            onChange({
                                ...data,
                                name
                            })
                        }}
                    />
                </div>
            </div>
            <div className={"columns"}>
                <div className={"column is-one-third"}>
                    <FieldSelect
                        options={fieldOptions}
                        label={"Feld"}
                        disabled={saving}
                        required={true}
                        invalid={Boolean(fieldHelp)}
                        help={fieldHelp}
                        value={field}
                        onBlur={async () => await validate()}
                        onChange={field => {
                            onChange({
                                ...data,
                                field: field as ScanDocumentRuleFieldTypeDto
                            })
                        }}
                    />
                </div><div className={"column is-one-third"}>
                {data.field === ScanDocumentRuleFieldTypeDto.DOCUMENT_TYPE &&
                <FieldSelect
                    options={valueOptionsDocumentType}
                    label={"Wert"}
                    disabled={saving}
                    required={true}
                    invalid={Boolean(valueHelp)}
                    help={valueHelp}
                    value={value}
                    onBlur={async () => await validate()}
                    onChange={value => {
                        onChange({
                            ...data,
                            value
                        })
                    }}
                /> }
                {data.field !== ScanDocumentRuleFieldTypeDto.DOCUMENT_TYPE &&
                    <FieldInput
                        label={"Wert"}
                        disabled={saving}
                        required={true}
                        invalid={Boolean(valueHelp)}
                        help={valueHelp}
                        value={value}
                        onBlur={async () => await validate()}
                        onChange={value => {
                            onChange({
                                ...data,
                                value
                            })
                        }}
                    /> }
                </div>
            </div>
            <div className={"columns"}>
                <div className={"column is-one-third"}>
                    <FieldSelect
                        options={actionOptions}
                        label={"Action"}
                        disabled={saving}
                        required={true}
                        invalid={Boolean(actionHelp)}
                        help={actionHelp}
                        value={action}
                        onBlur={async () => await validate()}
                        onChange={action => {
                            onChange({
                                ...data,
                                action: action as ScanDocumentRuleActionTypeDto
                            })
                        }}
                    />
                </div>
            </div>
        </div>
    </div>
})

export {
    CmsRuleForm
}
